import {
  Zap,
  Bot,
  Brain,
  Workflow,
  MessageSquare,
  Wrench,
  Shield,
  Building2,
  Activity,
  DollarSign,
  Gauge,
  type LucideIcon,
} from 'lucide-react'
import type { TFunction } from 'i18next'

export interface MenuItem {
  id: string
  path: string
  icon: LucideIcon
  label: string
  badge?: number
  requiresSuperadmin?: boolean
  /**
   * Só aparece para quem tem o módulo de atendimento.
   *
   * Turno, funil e transbordo não existem fora dele — mostrar a tela a quem não
   * o tem seria oferecer um gráfico que nunca terá dado.
   */
  requiresAtendimento?: boolean
  /** Título do grupo, escrito acima do PRIMEIRO item que o declara. */
  group?: string
}

export const getMenuItems = (t: TFunction): MenuItem[] => [
  { id: 'dashboard', path: '/dashboard', icon: Zap, label: t('nav.dashboard') },
  { id: 'organizations', path: '/organizations', icon: Building2, label: t('nav.organizations') },
  { id: 'agents', path: '/agents', icon: Bot, label: t('nav.agents') },
  { id: 'knowledge', path: '/knowledge-base', icon: Brain, label: t('nav.knowledgeBase') },
  { id: 'tools', path: '/tools', icon: Wrench, label: t('nav.tools') },
  { id: 'workflows', path: '/workflows', icon: Workflow, label: t('nav.workflows') },
  { id: 'chat', path: '/chat', icon: MessageSquare, label: t('nav.chat') },
  // AS DUAS DA PLATAFORMA. Execução e custo existem para qualquer agente, com
  // ou sem atendimento — por isso ficam na raiz do menu e não no grupo abaixo.
  { id: 'executions', path: '/executions', icon: Activity, label: t('nav.executions') },
  { id: 'costs', path: '/costs', icon: DollarSign, label: t('nav.costs') },
  // O GRUPO DO MÓDULO, hoje com UM item só.
  //
  // Canais, Operadores e Acervo NÃO entram: não existe endpoint para nenhum
  // deles, e item de menu que abre tela vazia é promessa que o servidor não
  // cumpre. Desempenho entra porque `metricas` tem router desde a F7.
  {
    id: 'atendimento-desempenho',
    path: '/atendimento/desempenho',
    icon: Gauge,
    label: t('nav.desempenho'),
    requiresAtendimento: true,
    group: t('nav.atendimento'),
  },
  { id: 'admin', path: '/admin', icon: Shield, label: t('nav.admin'), requiresSuperadmin: true },
]
